<template>
  <a
    class="dropdown-item"
    :class="{'is-disabled': disabled}"
    role="listitem"
    @click="select"
  >
    <slot/>
  </a>
</template>

<script setup lang="ts">
  import {inject} from 'vue';
  import {DROPDOWN} from '@/components/ui/dropdown';

  const props = withDefaults(defineProps<{
    disabled?: boolean;
  }>(), {
    disabled: false,
  });

  const emit = defineEmits<{
    click: [];
  }>();

  const dropdown = inject(DROPDOWN);

  function select(): void {
    if (props.disabled) {
      return;
    }
    emit('click');
    dropdown?.close();
  }
</script>
